module.exports = __webpack_public_path__ + "img/loreal.3e8ae4ed.png";